// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2FCPQ","row":"Node_row__3jvfc","label":"Node_label__7GCjr","footer":"Node_footer__3xI6f"};